import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


const AwardTwo = () => {
    return(
        <>
        {/*Award Section*/}
        <section className="award-section-two section-padding-bottom">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-4 order-md-1">
                <div className="sec-o-title text-right">
                    <h2 className="transform-uppercase">Archived <span>Award</span></h2>
                </div>
                </div>
                <div className="col-lg-8 order-md-2">
                <OwlCarousel
                    items={4}
                    loop={true}
                    nav={false}
                    dots={true}
                    autoplay={true} 
                    className="award-logos section-margin-no four-item-carousel owl-carousel">
                    <img src="images/award/1-01.png" alt="Award" />
                    <img src="images/award/2-01.png" alt="Award" />
                    <img src="images/award/3-01.png" alt="Award" />
                    <img src="images/award/4-01.png" alt="Award" />
                    <img src="images/award/5-01.png" alt="Award" />
                    <img src="images/award/1-01.png" alt="Award" />
                </OwlCarousel>
                </div>
            </div>
            </div>
        </section>
        {/*End Award Section*/}
        </>
    )
}

export default AwardTwo;